var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"gift-element"},[_c('div',{staticClass:"icon-wrapper"},[_c('div',{staticClass:"circle"})]),_c('div',{staticClass:"name"},[_c('div',{staticClass:"line h17 w40 m10"})])])
}]

export { render, staticRenderFns }